import { cacheDom } from "../utils/QuerySelectors.js"
import { getRebuyData } from "../utils/Rebuy.js"
import { makeid } from "../utils/helpers.js"
import { makeRequest, makeProduct } from "../utils/Storefront.js"

const dom = {}
const qs = {
  header: 'data-section-type="header"',
  announcement: 'data-announcement',
  announcementClose: 'data-announcement-close',
  searchForm: 'data-search-form',
  searchFormInner: 'data-search-form-inner',
  searchClear: 'data-search-clear',
  searchInput: 'data-search-input',
  searchResults: 'data-search-content',
  searchSuggestions: 'data-search-suggestions',
  mobileTrigger: 'data-mobile-trigger',
  mobileClose: 'data-mobile-close',
  mobileSearchClose: 'data-search-close',
  mobilePanel: 'data-mobile-panel',
  mobilePanelInner: 'data-mobile-panel-inner',
  mobilePanelMain: 'data-mobile-panel-main',
  // mobileBreadcrumb: 'data-mobile-breadcrumb',
  cartTrigger: 'data-cart-trigger',
  cartCount: 'data-cart-count',
  cartPanel: 'data-mini-cart-panel',
  cartPanelInner: 'data-mini-cart-panel-inner',
  cartClose: 'data-mini-cart-close', 
  desktopOverlay: 'data-megamenu-overlay',
  countrySelect: 'data-mobile-country-select',
  cartSwiper: 'data-cart-swiper',
}
const qsAll = {
  desktopParents: 'data-desktop-menu-parent',
  desktopMegamenus: 'data-megamenu',
  mobileParents: 'data-mobile-parent',
  qtyChanges: 'data-qty-change',
  suggetItems: 'data-storefront-item',
  searchTriggers: 'data-search-trigger',
}
const state = {
  wrapper: null,
  headerBounds: {},
  currentScrollTop: 0,
  searchInputTimer: null,
  scrollTimeout: null,
}

const createObserver = () => {
  let observer = new IntersectionObserver((entries, observer) => {
    state.headerBounds = entries[0].intersectionRect
    observer.disconnect()
  })

  observer.observe(state.wrapper)
}

const onScroll = () => {
  clearTimeout(state.scrollTimeout)
  if(!document.body.classList.contains('body-scrolling')) document.body.classList.add('body-scrolling')
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const addition = (document.querySelector('.main-collection-banner')?.offsetHeight + document.querySelector('.plp-visual-filter')?.offsetHeight) || 0
  
  if (scrollTop > state.currentScrollTop && scrollTop > state.headerBounds.bottom) {
    headerReveal()
  } else if (scrollTop < state.currentScrollTop && scrollTop > state.headerBounds.bottom) {
    headerReveal()
  } else if (scrollTop <= state.headerBounds.top) {
    headerHide()
  }

  state.currentScrollTop = scrollTop

  state.scrollTimeout = setTimeout(() => {
    document.body.classList.remove('body-scrolling')
  }, 200)
}

const headerReveal = () => {
  state.wrapper.classList.add('shopify-section-header-sticky')
  document.body.classList.add('header-sticky')
}
const headerHide = () => {
  state.wrapper.classList.remove('shopify-section-header-sticky')
  document.body.classList.remove('header-sticky')
}

const onSearchChange = () => {
  const searchTerm = dom.searchInput.value.trim()
  getSearchResults(searchTerm)
}
const initSearchSuggestions = () => {
  const slides = dom.searchForm.querySelectorAll(`[${qsAll.suggetItems}]:empty`)
  const ids = Array.from(slides).map(slide => `"gid://shopify/Product/${slide.dataset.storefrontItem}"`)
  const query = `{
    nodes(ids: [${ids.join(',')}]) {
      ...on Product {
        ${window.productResponse}
      }
    }
  }`
  makeRequest(
    (results) => {
      results.data.nodes.forEach(node => {
        const json = makeProduct(node)
        const slide = dom.searchForm.querySelector(`[${qsAll.suggetItems}="${json.id}"]`)
        const tile = document.createElement('div')
        tile.setAttribute('product-tile', json.id)
        tile.setAttribute('json', JSON.stringify(json))
        tile.setAttribute('lazyload', 'true')
        tile.setAttribute('search', 'true')
        tile.setAttribute('real_price', slide.getAttribute('data-real-price'))
        tile.setAttribute('real_comp_price', slide.getAttribute('data-real-comp-price'))
        slide.appendChild(tile)
      })
      window.setupProductTiles(dom.searchForm.querySelectorAll('[product-tile]:empty'))
      setTimeout(() => {
        window._swat.initializeActionButtons(`[${qs.searchForm}]`, '.plp-wishlist-btn')
      }, 1500)
    },
    query
  )
}
const getSearchResults = (searchTerm) => {
  fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=query,product,collection,page,article&resources[options][fields]=title,product_type,variants.title,body,vendor&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status)
        dom.searchSuggestions.classList.remove('hidden')
        dom.searchResults.innerHTML = ''
        throw error
      }
      console.log(response)
      return response.text()
    })
    .then((text) => {
      dom.searchSuggestions.classList.add('hidden')
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML
      dom.searchResults.innerHTML = resultsMarkup
      setTimeout(() => {
        window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
        setTimeout(() => {
          window._swat.initializeActionButtons(`[${qs.searchForm}]`, '.plp-wishlist-btn')
        }, 1500)
      }, 150)
      initSearchSuggestions()
    })
    .catch((error) => {
      initSearchSuggestions()
      throw error
    })
}

const openMobileMenu = () => {
  dom.mobilePanel.classList.add('!block')
  dom.mobileTrigger.classList.add('header-mobile-menu-trigger__active')
  document.body.classList.add('mobile-nav--opened')
  // Hide the header when mobile menu opens
  if(state.wrapper) {
    state.wrapper.style.display = 'none'
  }
}
const closeMobileMenu = () => {
  dom.mobilePanel.classList.remove('!block')
  dom.mobileTrigger.classList.remove('header-mobile-menu-trigger__active')
  document.body.classList.remove('mobile-nav--opened')
  // Show the header when mobile menu closes
  if(state.wrapper) {
    state.wrapper.style.display = ''
  }
}
const closeMobileSearch = () => {
  dom.searchForm.classList.remove('!block')
  dom.mobileTrigger.classList.remove('header-mobile-menu-trigger__active')
}
// const updateMobileBreadcrumb = () => {
//   const parentOpen = dom.mobilePanel.querySelector('details[open][data-mobile-parent]')
//   const childOpen = parentOpen ? parentOpen.querySelector('details[open][data-mobile-top]') : null
//   let breadcrumb = ''
//   if(parentOpen) {
//     if(childOpen) {
//       breadcrumb = `&nbsp;/&nbsp;${parentOpen.querySelector('summary').textContent.trim().toLowerCase()}&nbsp;/&nbsp;${childOpen.querySelector('summary').textContent.trim().toLowerCase()}`
//     } else {
//       breadcrumb = `&nbsp;/&nbsp;${parentOpen.querySelector('summary').textContent.trim().toLowerCase()}`
//     }
//   }
//   dom.mobileBreadcrumb.innerHTML = breadcrumb
// }

const updateCartHead = (cart) => {
  dom.cartTrigger.classList.toggle('header-cart--filled', cart.item_count > 0)
  if(cart.item_count > 0) {
    dom.cartCount.innerHTML = cart.item_count
  } else {
    dom.cartCount.innerHTML = ''
  }
}

window.updateCartHead = updateCartHead

const openCart = (open=true) => {
  dom.cartPanel.classList.toggle('!block', open)
  dom.cartPanel.classList.toggle('z-[102]', open)
  document.body.classList.toggle('overflow-hidden', open)
  document.body.classList.toggle('cart--opened', open)
  if(!open && dom.countrySelect) dom.countrySelect.removeAttribute('open')
  if(!dom.cartTrigger.dataset.inited) {
    dom.cartTrigger.setAttribute('data-inited', 'true')
    window.getCart((cart) => { initMiniCart(cart, true) })
  }
}
window.openCart = openCart

const cartUpsells = (cart, initUpsells=true) => {
  if(initUpsells) {
    const miniCartSwiper = document.querySelector(`[${qs.cartSwiper}]`)
    if(miniCartSwiper) {
      const swiperWrapper = miniCartSwiper.querySelector('.swiper-wrapper')
      const miniCartSwiperInstance = new Swiper(miniCartSwiper, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 1.3,
            spaceBetween: 40
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
      getRebuyData((products) => {
        console.log(products)
        let filteredProducts = []
        let groupIds = []
        products.forEach(product => {
          const metafield = product.metafields.filter(m => m.key == 'product_group' && m.namespace == 'leftonfriday')[0]
          if(metafield && !groupIds.includes(metafield.value)) {
            groupIds.push(metafield.value)
            filteredProducts.push(product)
          } else if ((typeof metafield == 'undefined') || !metafield) {
            filteredProducts.push(product)
          }
        })
        filteredProducts = filteredProducts.slice(0, 8)
        filteredProducts.forEach(product => {
          fetch(`/products/${product.handle}?view=data`)
          .then(response => {
            return response.json()
          })
          .then(result => {
            const id = `product-tile-${makeid(5)}`
            swiperWrapper.innerHTML +=  `
              <div class="swiper-slide h-full">
                <div class="h-full"
                  id="${id}"
                  product-tile 
                  json='${JSON.stringify(result).replace("'", "’")}'
                  lazyload='true'
                  columns_desktop='4'
                  columns_tablet='3'
                  columns_mobile='2'
                  showcase="true"
                ></div>
              </div>`
            setTimeout(() => {
              window.setupProductTiles(swiperWrapper.querySelectorAll(`#${id}`))
              miniCartSwiperInstance.update()
            }, 500)
          })
        })
        setTimeout(() => {
          miniCartSwiperInstance.update()
        }, 3000)
      }, miniCartSwiper.dataset.cartSwiper.trim(), cart.items.map(item => item.product_id).join(','), 40, true)
    }
  }
}

const initMiniCart = (cart, initUpsells=true) => {
  const cartClose = dom.cartPanel.querySelector(`[${qs.cartClose}]`)
  cartClose.addEventListener('click', () => {
    openCart(false)
  })
  const qtyChanges = dom.cartPanel.querySelectorAll(`[${qsAll.qtyChanges}]`)
  qtyChanges.forEach(qtyChange => {
    qtyChange.addEventListener('click', () => {
      window.changeLineItem((cart) => {
        if(qtyChange.dataset.qtyChange == 'gwp') Cookies.set('gwp_remove', true)
        initMiniCart(cart)
      }, {
        quantity: parseInt(qtyChange.dataset.quantity),
        id: qtyChange.dataset.itemKey,
      })
    })
  })
  cartUpsells(cart, initUpsells)
}
window.initMiniCart = initMiniCart

export const setupHeader = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.header) {
    state.wrapper = dom.header.closest('#shopify-section-header')
    window.addEventListener('scroll', onScroll, false)
    createObserver()
    new SV.HoverIntent(dom.desktopParents, {
      onEnter: (targetItem) => {
        targetItem.classList.add('header-menu--item__active')
        dom.header.classList.add('header-menu__active')
        if(dom.searchForm) closeMobileSearch()
      },
      onExit: (targetItem) => {
        targetItem.classList.remove('header-menu--item__active')
        dom.header.classList.remove('header-menu__active')
      },
      exitDelay: 400,
      interval: 100,
      sensitivity: 7,
    })
    dom.desktopMegamenus.forEach(desktopMegamenu => {
      desktopMegamenu.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    })
    
    dom.desktopOverlay.addEventListener('click', (e) => {
      e.stopPropagation()
      e.preventDefault()
      dom.desktopMegamenus.forEach(desktopMegamenu => desktopMegamenu.classList.remove('header-menu--item__active'))
      dom.header.classList.remove('header-menu__active')
    })

    // dom.header.addEventListener('mouseover', () => {
    //   if(!dom.cartTrigger.dataset.inited) {
    //     dom.cartTrigger.setAttribute('data-inited', 'true')
    //     window.getCart((cart) => { initMiniCart(cart, true) })
    //   }
    // })
    dom.cartTrigger.setAttribute('data-inited', 'true')
    window.getCart((cart) => {
      initMiniCart(cart, true)
      // Check for open_cart URL parameter and open cart if needed
      if (window.location.search.includes('open_cart=true')) {
        openCart(true)
      }
    })
  }
  if(dom.announcementClose) {
    dom.announcementClose.addEventListener('click', () => {
      document.body.classList.add('announcement-removed')
      dom.announcement.remove()
    })
  }
  if(dom.searchTriggers.length > 0) {
    dom.searchTriggers.forEach(searchTrigger => {
      searchTrigger.addEventListener('click', (e) => {
        e.stopPropagation()
        closeMobileMenu()
        dom.searchForm.classList.toggle('!block')
        
        // window.setupProductTiles(dom.searchForm.querySelectorAll('[product-tile]:empty'))
  
        if(dom.searchForm.classList.contains('!block')) {
          dom.searchInput.focus()
          dom.mobileTrigger.classList.add('header-mobile-menu-trigger__active')
        }
      })
    })
    
    dom.searchForm.addEventListener('click', (e) => {
      closeMobileSearch()
    })
    dom.mobileSearchClose.addEventListener('click', (e) => {
      closeMobileSearch()
    })
    window.addEventListener('click', () => {
      closeMobileSearch()
    })
    dom.searchFormInner.addEventListener('click', (e) => e.stopPropagation())
    dom.searchInput.addEventListener('input', () => {
      dom.searchClear.classList.toggle('!block', dom.searchInput.value != '')
      clearTimeout(state.searchInputTimer)
      state.searchInputTimer = setTimeout(() => {
        onSearchChange()
      }, 300)
    })

    dom.searchClear.addEventListener('click', () => {
      dom.searchInput.value = ''
      const inputEvent = new Event('input')
      dom.searchInput.dispatchEvent(inputEvent)
      dom.searchInput.focus()
    })
    initSearchSuggestions()
  }

  // Mobile Menu
  dom.mobileTrigger.addEventListener('click', (e) => {
    e.stopPropagation()
    if(dom.mobileTrigger.classList.contains('header-mobile-menu-trigger__active')) {
      closeMobileMenu()
      dom.searchForm.classList.remove('!block')
    } else {
      openMobileMenu()
    }
  })
  dom.mobileClose.addEventListener('click', (e) => {
    e.stopPropagation()
    closeMobileMenu()
    dom.searchForm.classList.remove('!block')
  })
  dom.mobilePanel.addEventListener('click', () => closeMobileMenu())
  dom.mobilePanelInner.addEventListener('click', (e) => e.stopPropagation())
  const mobileParentLis = Array.from(document.querySelectorAll('[data-mobile-menu-list] > li'))
  dom.mobileParents.forEach(mobileParent => {
    mobileParent.addEventListener('click', () => {
      setTimeout(() => {
        const currentLi = mobileParent.closest('li')
        mobileParentLis.forEach(li => li.classList.toggle('hidden', mobileParent.hasAttribute('open')))
        dom.mobilePanelMain.classList.toggle('mobile-panel-main__collapsed', mobileParent.hasAttribute('open'))
        currentLi.classList.remove('hidden', !mobileParent.hasAttribute('open'))
      }, 100)
      // setTimeout(() => {
      //   dom.mobileParents.forEach(mobileP => mobileP.toggleAttribute('open', (mobileP == mobileParent && mobileParent.hasAttribute('open'))))
      //   // updateMobileBreadcrumb()
      // }, 200)
    })
  })
  
  // Mini Bag
  dom.cartTrigger.addEventListener('click', (e) => {
    e.stopPropagation()
    openCart(!dom.cartPanel.classList.contains('!block'))
  })
  dom.cartPanelInner.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.cartPanel.addEventListener('click', (e) => {
    openCart(false)
  })
  window.addEventListener('click', () => {
    openCart(false)
  })
}